import React, { useState } from 'react'
import { useMissionElementsContext } from "../providers/missionElementsProvider";
import { useQuestionContext } from "../providers/questionProvider";

import { QuestionStatus, GameStatus } from "../constants";
import { useGameStatusContext } from "../providers/gameStatusProvider";
import Question from './../Board/Question/Question';
import ElementButton from './../components/ElementButton';

function getRandom(min = 0, max = 0) {
  return Math.floor(Math.random() * (+max - +min)) + +min;}

const isDispached = (q) => q.status === QuestionStatus.DISPATCHED;

const useRenderElementButton = (options) => {

  const [currentSelectedItem, setCurrentSelectedItem ] = useState(-1);


  const [gameStatus, setGameStatus] = useGameStatusContext();
  const {
    setCurrentAnswer,
    setCurrentQuestion,
    SetSelectedQuestion,
    setQuestionOpen,
  } = useQuestionContext();

  const [stateElements, dispatch] = useMissionElementsContext();

  const setQuestion = (question, element) => {

    const handleQuestionAnswered = (element, question, answer) => {
      setCurrentSelectedItem(-1);
      setCurrentAnswer(answer);
      setCurrentQuestion(question);
      dispatch({
        type: "SET_QUESTION_STATUS",
        payload: {
          options,
          round: gameStatus.round,
          questions: [question],
          status:
            answer.isCorrect === true
              ? QuestionStatus.ANSWERED_RIGHT
              : QuestionStatus.ANSWERED_WRONG,
        },
      });
    };

    setCurrentAnswer();
    setCurrentQuestion();
    if (question) {
      SetSelectedQuestion(
        <Question
          element={element}
          question={question}
          onOptionSelected={handleQuestionAnswered}
        />
      );
      setQuestionOpen(true);
    }
  };

  const renderElementButton = (element, gameStatus, coords, idx) => {
    console.log(element, coords);
    const questions = element.questions[gameStatus.round];
    const hasDispatched = questions.find(isDispached);
   
    const handleOnClick = (e) => {
      setCurrentSelectedItem(idx);

      console.log("useRenderElementButton" , idx);

      if (gameStatus.status !== GameStatus.STARTED) return null;

      if (!hasDispatched) return null;

      const roundQuestions = questions.filter(isDispached);

      if (setQuestion && roundQuestions && roundQuestions.length > 0) {
        const randomNum = getRandom(0, roundQuestions.length - 1);
        const poppedQuestion = roundQuestions[randomNum];
        setQuestion(poppedQuestion, element);
      }
    };

    const disabled = gameStatus.status === GameStatus.STOPPED || !hasDispatched && currentSelectedItem !== idx;
    const selected = currentSelectedItem === idx && !disabled;
 
    return (
      <ElementButton
        className={`element-btn ${currentSelectedItem !== -1 ? 'disabled' : ''}`}
        disabled={disabled}
        selected={selected}
        coords={coords}
        element={element}
        image={element.image}
        onClick={handleOnClick}
      />      
    );
  };

  return renderElementButton;
};

export default useRenderElementButton;
